export default function Mission() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-gray-900 font-['Montserrat']">
              Our Story
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-base">
                Tlotlo Mfolwe Incorporated is a consultancy and commodity trading entity registered in South Africa. Over 8 years, TMI has facilitated syndications and business linkages between buyers and sellers of various commodities, building strong relationships across the industry.
              </p>
              <p className="text-base">
                For five years, TMI consolidated its resources to focus on chrome transactions, building chrome processing plants and beneficiating chrome ore on a consultancy basis for clients. TMI has acquired a processing plant in Rustenburg where we beneficiate ROM into concentrate and sell to clients from the site.
              </p>
              <p className="text-base">
                Currently, our plant has the capacity to produce an average of 1000MT of final product on a weekly basis. It is TMI's immediate objective to enhance output to larger quantities in the nearest future. We source raw material from various mines and dumps located around the Northwest Province.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/80c96a8a0d3992f1ee1ed1106767944d.jpg"
                alt="TMI Chrome Processing Plant"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mt-24">
          <div className="bg-gradient-to-br from-red-50 to-gray-50 p-10 rounded-lg">
            <div className="w-16 h-16 bg-[#8B1538] rounded-full flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900 font-['Montserrat']">TMI Vision</h3>
            <p className="text-gray-700 leading-relaxed text-base">
              TMI aims to be the sought-after chrome supplier guaranteeing strong relationships with its raw material suppliers and its clients and all stakeholders in its operating environment in order to deliver client-centric solutions and create value so that it is sustained in the long term.
            </p>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-gray-50 p-10 rounded-lg">
            <div className="w-16 h-16 bg-[#8B1538] rounded-full flex items-center justify-center mb-6">
              <i className="ri-compass-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900 font-['Montserrat']">TMI Mission Statement</h3>
            <p className="text-gray-700 leading-relaxed text-base">
              TMI strives to become a premium JIT supplier of quality chrome products to its clients. To attain this goal, TMI has partnered with local transporters to deliver raw material from the mine to processing plant. TMI is continually developing innovative and effective supply chain processes in order to meet its clients' needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
